module.exports = __webpack_public_path__ + "static/media/phone_black3.ec2c605f.png";